import React from 'react';
import { DesBanner, MultiBanner } from './banners';

interface UpmarketBannersVariantTypes {
  upmarketBannerVariants: {
    withDesBanner: boolean;
    withMultiVariantBanner: boolean;
  };
}

export const UpmarketBanners: React.FC<UpmarketBannersVariantTypes> = ({ upmarketBannerVariants }) => {
  const { withDesBanner, withMultiVariantBanner } = upmarketBannerVariants;

  if (!withDesBanner && !withMultiVariantBanner) {
    return null;
  }

  return (
    <>
      {withDesBanner && <DesBanner />}
      {withMultiVariantBanner && <MultiBanner />}
    </>
  );
};

export default UpmarketBanners;
